import { useQuery } from 'react-query';
import { dsoIdsStoreSettingsService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useDsoIdsStoreSettings = () => {
  return useQuery(
    [ServerStateKeysEnum.dsoIdsStoreSettings],
    () => dsoIdsStoreSettingsService.getIdsStoreSettings(),
    {
      staleTime: Infinity,
      retry: false,
    }
  );
};
